// extracted by mini-css-extract-plugin
export default {"imageWrapper":"gJ-z","twoColumnImage":"hJ-z"};